<template>
  <div id="app">
    <!-- 使用 PascalCase 组件名 -->
    <AppHeader />
    <main class="main-content">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
    <AppFooter />
  </div>
</template>

<script setup>
import AppHeader from "./components/layout/AppHeader.vue";
import AppFooter from "./components/layout/AppFooter.vue";
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: "Arial", sans-serif;
}

.main-content {
  flex: 1;
  width: 100%;
  /* padding: 20px; */
  margin: 0 auto;
  /* background-color: #f5f5f5; */
}

/* 路由过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .main-content {
    width: 70%;
  }
}

@media (max-width: 768px) {
  .main-content {
    width: 90%;
    margin: 10px auto;
    padding: 15px;
  }

  .header-container {
    flex-direction: column;
    height: auto;
    padding: 15px;
  }

  .nav-list {
    margin-top: 15px;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
  }
}

@media (max-width: 480px) {
  .main-content {
    width: 95%;
  }

  .footer-content {
    grid-template-columns: 1fr;
    text-align: center;
  }
}
</style>